import { __rest as e } from "../_virtual/_tslib.js";
import { jsx as r } from "react/jsx-runtime";
import { Body as o } from "@vds-core/typography";
import { ColorTokens as t } from "@vds-tokens/color";
var i = function i(_i) {
  var s = _i.viewport,
    a = _i.children,
    l = _i.surface,
    n = e(_i, ["viewport", "children", "surface"]),
    c = "mobile" === s;
  return r(o, Object.assign({
    viewport: s,
    color: "dark" === l ? t.elements.secondary.ondark.value : t.elements.secondary.onlight.value,
    size: c ? "small" : "large",
    tabIndex: -1
  }, n, {
    children: a
  }));
};
i.defaultProps = {
  surface: "light"
}, i.displayName = "AccordionSubTitle";
export { i as default };